import { ChatCompletionMessage } from 'openai/resources/chat';

interface OpenAILog {
  timestamp: string;
  prompt: string;
  response: string | null;
  error?: string;
  extractedData?: any;
}

const logs: OpenAILog[] = [];

export function logOpenAIInteraction(
  messages: ChatCompletionMessage[],
  response: string | null,
  error?: string
) {
  const prompt = messages
    .map(m => `${m.role.toUpperCase()}: ${m.content}`)
    .join('\n\n');

  let extractedData;
  if (response) {
    try {
      extractedData = JSON.parse(response);
    } catch (e) {
      // Ignore parse errors for logging
    }
  }

  const log: OpenAILog = {
    timestamp: new Date().toISOString(),
    prompt,
    response,
    error,
    extractedData
  };

  logs.push(log);

  // Enhanced console logging
  console.group('%cOpenAI Interaction', 'color: #4f46e5; font-weight: bold;');
  console.log(
    '%cTimestamp%c: %s',
    'color: #666; font-weight: bold;',
    'color: inherit;',
    log.timestamp
  );
  
  console.log(
    '%cPrompt%c:\n%s',
    'color: #666; font-weight: bold;',
    'color: inherit;',
    log.prompt
  );
  
  console.log(
    '%cResponse%c:\n%s',
    'color: #666; font-weight: bold;',
    'color: inherit;',
    response || 'No response'
  );

  if (extractedData) {
    console.log('%cExtracted Data:', 'color: #666; font-weight: bold;');
    console.table(extractedData);
  }

  if (error) {
    console.error('%cError%c: %s',
      'color: #dc2626; font-weight: bold;',
      'color: inherit;',
      error
    );
  }
  console.groupEnd();

  // Keep only last 10 logs
  if (logs.length > 10) {
    logs.shift();
  }
}

export function getOpenAILogs(): OpenAILog[] {
  return [...logs];
}